import React, { useState, useEffect } from 'react';
import { session } from '../../services/session';
import { api } from '../../services/api';

import './search-modal.scss';

let timeout = null;

function SearchModal({ setPage, setStory }) {
  const [search, setSearch] = useState('');
  const [stories, setStories] = useState([]);

  useEffect(() => {
    if (timeout) {
      clearTimeout(timeout);
    }

    const url = `/api/v0/publishers/${session.orgId}/edits/`;
    const params = {
      limit: 50,
      q: search || null,
      is_mobile: true,
    };

    timeout = setTimeout(() => {
      api
        .get(url, params)
        .then(response => {
          setStories(response.data.data.filter(story => story.name));
        })
        .catch(() => {
          setStories([]);
        });
    }, 500);
  }, [search]);

  const results = stories.map((story, i) => {
    return (
      <div
        className="story"
        key={`story-${i}`}
        onClick={() => {
          setStory(story);
          setPage('link');
        }}
      >
        {story.name}
      </div>
    );
  });

  return (
    <div className="search-modal">
      <div className="search-container">
        <span className="dropdown-icon" onClick={() => setPage('link')}></span>
        <div className="search-bar">
          <span className="narrativ-icon search"></span>
          <input
            className="search-input"
            placeholder="Search for a Story"
            onChange={e => setSearch(e.target.value)}
            value={search}
          />
        </div>
      </div>
      <div className="results">
        <div className="story create-new" onClick={() => setPage('story')}>
          + Create New Story
        </div>
        {results}
      </div>
    </div>
  );
}

export default SearchModal;
